import type { CommandMenuRequest } from "@/contexts/command-menu-context";

/**
 * Kory's open_search (a gateway tool, for voice and the tray): what to open on the person's screen,
 * from a voice tool result (`{ open_search: { query, page }, say }`) or the tray stream's
 * `open_search` event (`{ query, page }`). Null when it carries neither.
 */
export function openSearchRequest(value: unknown): CommandMenuRequest | null {
  if (!value || typeof value !== "object") return null;
  const inner = "open_search" in value ? value.open_search : value;
  if (!inner || typeof inner !== "object") return null;
  const { query, page } = inner as { query?: unknown; page?: unknown };
  if (typeof query !== "string" && typeof page !== "string") return null;
  return { query: typeof query === "string" ? query : "", page: typeof page === "string" ? page : "" };
}
